import React from "react"
import { createRoot } from "react-dom/client"
import App from "./components/App"

const domContainer = document.querySelector("#body");
const root = createRoot(domContainer);

root.render(<App />);